import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TimerIcon from '@/assets/img/TimerIcon.png';

const useStyles = makeStyles(() => ({
  wrap: {
    '@media print': {
      display: 'none',
    },
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#FF3333',
    display: 'inline-block',
    marginLeft: '30px',
    verticalAlign: 'middle',
  },
  icon: {
    marginRight: '12px',
    marginBottom: '-2px',
  },
  hours: {},
  minutes: {},
  seconds: {},
}));

const Timer = ({ time, onEnd, className }) => {
  const [counter, setCounter] = React.useState(time);
  const classes = useStyles();

  React.useEffect(() => {
    if (counter === 0) {
      onEnd();
    }
    return counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  return (
    <div className={`${classes.wrap} ${className}`}>
      <img src={TimerIcon} alt="" className={classes.icon} />
      <span className={classes.hours}>
        {Math.floor(counter / 3600)
          .toString()
          .padStart(2, 0)}
      </span>
      :
      <span className={classes.minutes}>
        {Math.floor(counter / 60)
          .toString()
          .padStart(2, 0)}
      </span>
      :
      <span className={classes.seconds}>
        {(counter - Math.floor(counter / 60) * 60).toString().padStart(2, 0)}
      </span>
    </div>
  );
};

Timer.propTypes = {
  time: PropTypes.number.isRequired,
  onEnd: PropTypes.func.isRequired,
  className: PropTypes.func,
};

Timer.defaultProps = {
  className: '',
};

export default Timer;
